export default __webpack_public_path__ + "static/blog_hero-624a9732336efc9695b91c5ccd98a3b1.svg";